import { IsEmail } from 'class-validator';

export class RecoverPasswordForm {
  @IsEmail()
  email: string;
}
